import React from 'react';
import InlineValidationMessage from '../InlineValidationMessage';

export const InputFieldWithValidation = ({ input, label, placeholder, autoFocus, type, meta: { touched, error } }) => (
    <div>
        <label>{label}</label>
        <input {...input} placeholder={placeholder} autoFocus={autoFocus} type={type} />
        <InlineValidationMessage touched={touched} error={error} />
    </div>
);

export const TextareaFieldWithValidation = ({ input, label, placeholder, type, meta: { touched, error } }) => (
    <div>
        <label>{label}</label>
        <textarea {...input} placeholder={placeholder} type={type} />
        <InlineValidationMessage touched={touched} error={error} />
    </div>
);


// WEBPACK FOOTER //
// ./src/components/common/FormComponents/index.js